export const retrieveCheckindata = async (
    token,
    member_id,
    type,
    searchText,
    limit,
    index
  ) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);
  
    const raw = JSON.stringify({
      user_id: member_id,
      type:type,
      search_text: searchText,
      limit: limit,
      index: index,
    });
  
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
  
    try {
      const response = await fetch(
        `${window.constants.api_url}/biomatric/retrive-attendance`,
        requestOptions
      );
      const result = await response.json();
      return result;
    } catch (error) {
      throw new Error("Failed to retrieve user: " + error.message);
    }
  };


  export const Manualcheckout = async (userToken, id) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${userToken}`);
  
      const requestBody = {
        id: id,
       
      };
  
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(requestBody),
        redirect: "follow",
      };
  
      const response = await fetch(
        `${window.constants.api_url}/biomatric/mannual-checkout`,
        requestOptions
      );
      const result = await response.json(); // Parse response as JSON
      return result;
    } catch (error) {
      throw new Error("Failed to mannual checkout: " + error.message);
    }
  };
  
  export const StoreBiometric = async (userToken) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
    
  
     
  
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
  
      const response = await fetch(
        `${window.constants.api_url}/biomatric/store-attendance`,
        requestOptions
      );
      const result = await response.json(); // Parse response as JSON
      return result;
    } catch (error) {
      throw new Error("Failed to mannual checkout: " + error.message);
    }
  };
  export const GetTotalWorkHour = async (
    token,
    user_id,
    
  ) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);
  
    const raw = JSON.stringify({
      user_id: user_id,
     
    });
  
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
  
    try {
      const response = await fetch(
        `${window.constants.api_url}/biomatric/totalwork-hour`,
        requestOptions
      );
      const result = await response.json();
      return result;
    } catch (error) {
      throw new Error("Failed to retrieve user: " + error.message);
    }
  };
  export const GenerateSalary = async (
    token,
    userId,
    workHours,
    hoursPerDay,
    salaryPerDay,

  ) => {
    const totalDays = workHours / hoursPerDay;
    const totalSalary = totalDays * salaryPerDay;
  
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);
  
    const payload = {
      userId,
      workHours,
      hoursPerDay,
      salaryPerDay,
      totalSalary,
      date: new Date(),
    };
  
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(payload),
      redirect: "follow",
    };
  
    try {
      const response = await fetch(`${window.constants.api_url}/salary/generate`, requestOptions);
      const result = await response.json();
      return result;
    } catch (error) {
      throw new Error("Salary generation failed: " + error.message);
    }
  };

  export const getLeaveDays = async (token, employeeId, year, month) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ employee_id: employeeId, year, month }),
      redirect: "follow",
    };

    try {
      const response = await fetch(`${window.constants.api_url}/salary/leave-days/get`, requestOptions);
      return response.json();
    } catch (error) {
      throw new Error("Failed to fetch leave days: " + error.message);
    }
  };

  export const setLeaveDays = async (token, employeeId, year, month, leaveDays) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ employee_id: employeeId, year, month, leave_days: leaveDays }),
      redirect: "follow",
    };

    try {
      const response = await fetch(`${window.constants.api_url}/salary/leave-days/set`, requestOptions);
      return response.json();
    } catch (error) {
      throw new Error("Failed to save leave days: " + error.message);
    }
  };

 